import { render, staticRenderFns } from "./Socialist.vue?vue&type=template&id=3687b2ea&scoped=true&"
import script from "./Socialist.vue?vue&type=script&lang=js&"
export * from "./Socialist.vue?vue&type=script&lang=js&"
import style0 from "./Socialist.vue?vue&type=style&index=0&id=3687b2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3687b2ea",
  null
  
)

export default component.exports